import { produce } from 'immer';

import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  EDITING_DOCUMENT__FIELD_CREATE,
  EDITING_DOCUMENT__FIELD_POSITION_CHANGE,
  PDF_CLEAR_ALL_STATE,
} from '@app/store/actionTypes';
import { EditingDocumentAction } from '@app/store/editingDocument/actions';

export interface EditingDocumentPositionsState {
  [id: string]: {
    page: number;
    relativeX: number;
    relativeY: number;
  };
}

const initialState: EditingDocumentPositionsState = {};

export default function reducer(
  state: EditingDocumentPositionsState = initialState,
  action: EditingDocumentAction | PdfAction
) {
  switch (action.type) {
    case EDITING_DOCUMENT__FIELD_CREATE:
      return produce(state, (draft) => {
        const { page, relativeX, relativeY, uuid } = action.payload.meta;
        draft[uuid] = {
          page,
          relativeX,
          relativeY,
        };
      });
    case EDITING_DOCUMENT__FIELD_POSITION_CHANGE:
      return produce(state, (draft) => {
        const { relativeX, relativeY, uuid } = action.payload;
        draft[uuid].relativeX = relativeX;
        draft[uuid].relativeY = relativeY;
      });
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    default:
      return state;
  }
}
